import { ChangeEvent } from "react";
import { InputStyle, MergeWithOverwrite, ValidationErrorStyle } from "src/common";
import { InputLabel } from "src/components";

export type InputNumberProps = MergeWithOverwrite<React.InputHTMLAttributes<HTMLInputElement>, {
  label?: string;
  value?: string;
  error?: string;
  onChange?: (value: string) => void;
}
>;

export const InputNumber: React.FC<InputNumberProps> = ({
  label,
  error = '',
  value = '',
  onChange,
  ...props
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e.target.value);
  }

  return (
    <div>
      {label ? <InputLabel htmlFor={props.id} disabled={props.disabled}>{label}</InputLabel> : null}
      <InputStyle
        autoComplete="off"
        {...props}
        type='number'
        id={props.id}
        onChange={handleChange}
        hasError={!!error}
        value={value}
      />
      {error ? <ValidationErrorStyle>{error}</ValidationErrorStyle> : null}
    </div>
  );
};
